import { AppEntity, PostalAddressSchema } from '@app/icare/db/schema/common'
import { msg } from '@lingui/core/macro'
import { entityId } from '@pkg/db/schema'
import { defineEnum } from '@pkg/shared/utils/enum-builder'
import { z } from 'zod'

export const MedicalSpecialityEnum = defineEnum({
  EMERGENCY: msg`Ambulanz`,
  SPECIAL_CLINIC: msg`Spezialklinik`,
  GERIATRIC: msg`Geriatrische Klinik`,
  PSYCHIATRIC: msg`Psychiatrie`,
  PRIMARY_CARE: msg`Klinik`,
  REHAB: msg`Rehaklinik`,
})

export type MedicalSpecialityType = typeof MedicalSpecialityEnum.$.Type

export const medicalSpecialityFromSage = (val: string): typeof MedicalSpecialityEnum.$.Type | undefined => {
  switch (val) {
    case 'Ambulanz':
      return MedicalSpecialityEnum.EMERGENCY
    case 'Fachklinik':
      return MedicalSpecialityEnum.SPECIAL_CLINIC
    case 'Geriatrie':
      return MedicalSpecialityEnum.GERIATRIC
    case 'Klinik-Psy':
      return MedicalSpecialityEnum.PSYCHIATRIC
    case 'Klinik':
      return MedicalSpecialityEnum.PRIMARY_CARE
    case 'Reha':
      return MedicalSpecialityEnum.REHAB
    default:
      return undefined
  }
}

export const medicalSpecialityToSage = (val: typeof MedicalSpecialityEnum.$.Type) => {
  switch (val) {
    case MedicalSpecialityEnum.EMERGENCY:
      return 'Ambulanz'
    case MedicalSpecialityEnum.SPECIAL_CLINIC:
      return 'Fachklinik'
    case MedicalSpecialityEnum.GERIATRIC:
      return 'Geriatrie'
    case MedicalSpecialityEnum.PSYCHIATRIC:
      return 'Klinik-Psy'
    case MedicalSpecialityEnum.PRIMARY_CARE:
      return 'Klinik'
    case MedicalSpecialityEnum.REHAB:
      return 'Reha'
    default:
      return undefined
  }
}

export const ClinicId = entityId('clinic')

export type ClinicIdType = typeof ClinicId.Type

export const ClinicSchema = AppEntity.extend({
  id: ClinicId.schema,
  name: z.string().min(1),
  speciality: z.enum(MedicalSpecialityEnum.$.zodEnum()),
  addition: z.string().nullish(),
  comment: z.string().nullish(),
  address: PostalAddressSchema.nullish(),
})

export type Clinic = z.infer<typeof ClinicSchema>
